

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Address } from "@/models/Address";
import { IAddressService } from "@/modules/Segmentation/services/IAddressService";
import { container } from "@/services/registerServiceProvider";
import debounce from "./debounce";
import { NotificationStore } from '@/services/implementations/NotificationStore';

@Component
export default class AddressSearchForm extends Vue {
  @Prop() public value!: Address[];
  public readonly items: Address[] = [];
  public errorMessage: string = '';
  public errorMessageVisible: boolean = false;
  private readonly addressService: IAddressService =
    container.resolve("IAddressService");
  private static includesAddress(address1: string, address2: string): boolean {
    const region1 = address1.slice(0, 2);
    const district1 = address1.slice(2, 5);

    const region2 = address2.slice(0, 2);
    const district2 = address2.slice(2, 5);
    const locality1 = Number(address2.slice(2, 8)) === 0;
    const locality2 = Number(address2.slice(5, 8)) === 0;

    return (region1 === region2 && locality1) || (region1 === region2 && district1 === district2 && locality2);
  }

  setSelectedArray(newValue: Address[]) {
    const newAddress = newValue[newValue.length - 1];
    /**
     * 2 кейса:
     * 1) в value уже есть kladr, который "перекрывает" текущий
     * 2) в value есть kladr'ы, которые "входят" в новый
     * адрес состоит из 2 символов кода региона, 2х символов кода района и 3х символов населённого пункта
     **/
    if (this.value.length > 0 && newValue.length > this.value.length) {
      if (this.value.some((el) => { // вариант 1
        return AddressSearchForm.includesAddress(newAddress.kladr, el.kladr);
      })) {
        const region : Address | undefined = newValue.find(el => AddressSearchForm.includesAddress(newAddress.kladr, el.kladr));
        NotificationStore.getInstance().message = `Регион/район "${region?.presentation}" уже был закрыт целиком`;
        NotificationStore.getInstance().status = true;
        newValue.pop();
      }
      if (this.value.some((el) => {
        return AddressSearchForm.includesAddress(el.kladr, newAddress.kladr);
      })) {
        const answer = confirm('Вы закрываете район/регион целиком. Удалить ранее выбранные районы/города этого региона/района?');
        if (answer) {
          newValue = newValue.filter(address => {
            return !AddressSearchForm.includesAddress(address.kladr, newAddress.kladr);
          });
          newValue.push(newAddress);
        } else {
          newValue.pop();
        }
      }
    }
    this.$emit("input", newValue);
  }

  search(searchStr: string) {
    if(searchStr.length < 3) {
      return;
    }

    this.addressService.search(searchStr).then((data) => {
      if (data.length > 0) {
        this.items.splice(0, this.items.length, ...data);
      }
    });
  }

  delayedSearch = debounce(this.search, 500);
}
